const centsToDollars = value => {
    return `$${(value / 100).toFixed(2)}`
}

export { centsToDollars }
